import debounce from "lodash.debounce";
import { useEffect, useState, useRef } from "react";

const BASE_DELAY = 100;

export const useWindowSize = (delay = BASE_DELAY) => {
  const [windowSize, setWindowSize] = useState({
    screenWidth: undefined,
    screenHeight: undefined,
  });
  const isMounted = useRef(true);

  useEffect(() => {
    const handleResize = debounce(() => {
      if (isMounted.current) {
        setWindowSize({
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
        });
      }
    }, delay);

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      isMounted.current = false;
      handleResize.cancel();
      window.removeEventListener("resize", handleResize);
    };
  }, [delay]);

  return windowSize;
};
